import { MultiSelectGroup } from '../MultiselectDropdown';
import { AdvisePermission } from '../../../store/GeneralStore';
import { ADVISE_ANALYSTS, Role } from '../../../store/Role';

export const ADVISE_GROUP_TITLE = 'Advise';

const STAFF_ROLES_EXCLUDING_ADVISE: string[] = [Role.SDM, Role.EXECUTIVE_FULL, Role.EXECUTIVE_VIEW];
// Support sits on no team and the client Team Manager on a client one, while an Analyst or Advise Team Manager must
// sit on an internal team. An Admin holding one of those sits on its practice's team.
const NON_INTERNAL_TEAM_ROLES: string[] = [Role.SUPPORT, Role.TEAM_MANAGER];

const analystItem = (analyst: string) => ({
  label: analyst.replace('Advise - ', ''),
  options: Object.values(AdvisePermission),
  mutualExclusiveWith: [
    Role.ADVISE_REVIEW,
    ...ADVISE_ANALYSTS.filter((other) => other !== analyst),
    ...STAFF_ROLES_EXCLUDING_ADVISE,
    ...NON_INTERNAL_TEAM_ROLES
  ]
});

export const ADVISE_ROLE_GROUP: MultiSelectGroup = {
  title: ADVISE_GROUP_TITLE,
  items: [
    {
      label: 'Team Manager',
      options: Object.values(AdvisePermission),
      mutualExclusiveWith: [Role.ADVISE_REVIEW, ...STAFF_ROLES_EXCLUDING_ADVISE, ...NON_INTERNAL_TEAM_ROLES]
    },
    {
      label: 'Review',
      options: Object.values(AdvisePermission),
      mutualExclusiveWith: [Role.ADVISE_TEAM_MANAGER, ...ADVISE_ANALYSTS, ...STAFF_ROLES_EXCLUDING_ADVISE]
    },
    ...ADVISE_ANALYSTS.map(analystItem)
  ]
};

export const adviseGroupFor = (canGrantTeamManager: boolean): MultiSelectGroup =>
  canGrantTeamManager
    ? ADVISE_ROLE_GROUP
    : { ...ADVISE_ROLE_GROUP, items: ADVISE_ROLE_GROUP.items.filter((item) => item.label !== 'Team Manager') };

// An Advise Team Manager grants only the Analyst role of their own practice, which they hold themselves.
export const adviseGroupsLimitedTo = (roleNames: string[]): MultiSelectGroup[] => {
  const items = ADVISE_ROLE_GROUP.items.filter((item) => {
    const name = adviseRoleName(item.label);
    return ADVISE_ANALYSTS.includes(name) && roleNames.includes(name);
  });
  return items.length ? [{ ...ADVISE_ROLE_GROUP, items }] : [];
};

export const adviseRoleName = (label: string) => `${ADVISE_GROUP_TITLE} - ${label}`;
